import { TOKEN_RE } from './templateUtils';

const PreviewContent = ({ message, variables }) => {
    if (!message) return null;
    const allowed = new Set((variables || []).map((v) => v.key));
    const varMap = {};
    (variables || []).forEach((v) => { varMap[v.key] = v.example || `[${v.key}]`; });

    const html = message.replace(TOKEN_RE, (token) => {
        const match = token.match(/^\{\{([^}]+)\}\}$/);
        if (!match) return token;
        const key = match[1];
        if (allowed.has(key)) return varMap[key];
        return `<span class="text-danger fw-semibold">${token}</span>`;
    });

    return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export default PreviewContent;
